import Watermark from './watermark';
import { WatermarkProps } from './interface';

export { WatermarkProps };

export default Watermark;
